import { useParams } from "react-router-dom";
import { updateUserPartner } from "../../../services/Api/adminService";
import { usePartnerStore } from "../../../stores/admin/users";
import { useEffect } from "react";
import { getRoleList } from "../../../services/Api/roleService";
import { getUserById } from "../../../services/Api/partnerService";
import { useServiceStore } from "../../../stores/admin/service";
import { showToastError } from "../../../services/Toasts/toasts";

const UpdateUserPartner = ({ id, closeModal }: any) => {
  const { idPartner } = useParams();
  const { idRole, setIdRole, roles, setRoles } = usePartnerStore();
  const { update, setUpdate } = useServiceStore();

  useEffect(() => {
    getUserById(Number(idPartner), Number(id))
      .then((res) => setIdRole(res.data.idRole))
      .catch(() => showToastError("Une erreur s'est produite"));

    getRoleList()
      .then((data) => {
        const formattedRole = data?.map((role: any) => ({
          value: role.id,
          label: role.role,
        }));
        setRoles(formattedRole);
        setIdRole(formattedRole.find((el: any) => el.id === idRole));
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  }, [id]);

  const handleUpdateUser = () => {
    const data = {
      idRole,
    };
    updateUserPartner(Number(idPartner), Number(id), data)
      .then(() => {
        setUpdate(!update);
        closeModal();
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-hidden focus:outline-hidden">
        <div className="relative w-auto md:w-1/4 my-6 mx-auto max-w-3xl min-w-[45%]">
          {/* Content */}
          <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-hidden focus:outline-hidden">
            {/* Header */}
            <div className="w-full bg-white p-3 rounded-t-xl">
              <h4 className="text-xl font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <svg className="w-5 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.586a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                Modification d'un utilisateur
              </h4>
            </div>
            {/* Body */}
            <div className="w-full flex flex-col items-center justify-center text-grey-trio">
              <div className="flex flex-col justify-start items-start w-11/12 mb-6">
                <div className="w-full mb-4">
                  <label
                    htmlFor="role"
                    className="text-md sm:text-lg my-2 block text-gray-700 font-medium"
                  >
                    Rôle :
                  </label>
                  <select
                    className="w-full border border-gray-300 h-12 bg-white rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm transition-all duration-200"
                    value={idRole || ""}
                    onChange={(e) => setIdRole(parseInt(e.target.value))}
                    name="role"
                    id="role"
                    required
                  >
                    <option value="">Sélectionner un rôle</option>
                    {roles?.map((role) => (
                      <option key={role.value} value={role.value}>
                        {role.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="w-full bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <div className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <p className="text-sm text-blue-800 font-medium mb-1">Information</p>
                      <p className="text-sm text-blue-700">
                        Modifiez le rôle de l'utilisateur. Le changement sera appliqué immédiatement et affectera les permissions de l'utilisateur.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end p-3 rounded-b-2xl bg-white gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-500 hover:bg-red-500 hover:text-white cursor-pointer font-semibold rounded-xl transition-all duration-200 flex items-center gap-2 text-sm"
                type="button"
                onClick={() => closeModal()}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Annuler
              </button>
              <button
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 cursor-pointer text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2 text-sm"
                type="button"
                onClick={() => {
                  handleUpdateUser();
                }}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.586a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                Modifier
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default UpdateUserPartner;
